function initCarousels() {
    const carousels = document.querySelectorAll('.js-carousel');

    carousels.forEach((carousel) => {
        const wrapper = carousel.querySelector('.js-carousel__wrapper');
        const prevBtn = carousel.querySelector('.js-carousel__controls--prev');
        const nextBtn = carousel.querySelector('.js-carousel__controls--next');

        const emblaApi = EmblaCarousel(wrapper, { loop: false });

        const toggleButtons = () => {
            prevBtn.disabled = !emblaApi.canScrollPrev();
            nextBtn.disabled = !emblaApi.canScrollNext();
        };

        // initial state
        toggleButtons();

        // update on slide
        emblaApi.on('select', toggleButtons);

        // attach button listeners
        prevBtn.addEventListener('click', () => emblaApi.scrollPrev());
        nextBtn.addEventListener('click', () => emblaApi.scrollNext());
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
} else {
    initCarousels();
}

export default initCarousels;